"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerLoader = void 0;
const SpinnerLoader_1 = __importDefault(require("./SpinnerLoader"));
exports.SpinnerLoader = SpinnerLoader_1.default;
exports.default = SpinnerLoader_1.default;
